import styled from 'styled-components'
import Colors from '../../themes/Colors'

const AppHolder = styled.div`
  background-color: ${Colors.background};  

  .ant-btn-primary{
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
    color: ${Colors.onPrimary};
  }

  .ant-btn-primary[disabled],
  .ant-btn-primary[disabled]:hover,
  .ant-btn-primary[disabled]:focus,
  .ant-btn-primary[disabled]:active,
  .ant-btn-danger[disabled],
  .ant-btn-danger[disabled]:hover,
  .ant-btn-danger[disabled]:focus,
  .ant-btn-danger[disabled]:active {
    background-color: ${Colors.surfaceMuted};
    border-color: ${Colors.borderStrong};
    color: ${Colors.textMuted};
  }
`;

export default AppHolder;